// extracted by mini-css-extract-plugin
module.exports = {"rootWrapper":"w0Vd8","contentWrapper":"SKAWI","isSidebar":"opnsM","collapsed":"RblBq"};